import { Component, inject, output, signal, ViewChild } from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ButtonComponent } from '@components/buttons/button/button.component';
import { IconButtonComponent } from '@components/buttons/icon-button/icon-button.component';
import { environment } from '@shared/envs/env';
import { SnackbarService, SnackbarType } from '@shared/helper/snackbar.service';
import { SupportService } from '@shared/services/support.service';
import { RecaptchaComponent, RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha-2';

@Component({
  selector: 'app-support-data',
  imports: [
    IconButtonComponent,
    FormsModule,
    ReactiveFormsModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    ButtonComponent,
  ],
  providers: [SupportService],
  templateUrl: './support-data.component.html',
  styleUrl: './support-data.component.scss',
})
export class SupportDataComponent {
  @ViewChild('captchaElem') captchaElem!: RecaptchaComponent;
  siteKey = environment.recaptchaKey;
  form = new FormGroup({
    recaptcha: new FormControl('', [Validators.required]),
    text: new FormControl<string | null>(null, [Validators.required]),
  });
  submitted = signal(false);
  close = output();

  private readonly supportService = inject(SupportService);
  private readonly snackbar = inject(SnackbarService);

  submitForm() {
    if (this.form.controls.text.invalid) {
      this.form.controls.text.markAsTouched();
      this.snackbar.showSnackbar('پیام نمی‌تواند خالی باشد', SnackbarType.warning);
      return;
    }
    if (this.form.controls.recaptcha.invalid) {
      this.form.controls.recaptcha.markAsTouched();
      this.snackbar.showSnackbar('گزینه‌ی من ربات نیستم را تایید کنید', SnackbarType.warning);
      return;
    }
    this.submitted.set(true);
    this.supportService
      .submitSupport({
        data: {
          text: this.form.value.text!,
          token: this.form.value.recaptcha!,
        },
      })
      .subscribe({
        next: (res) => {
          this.submitted.set(false);
          this.snackbar.showSnackbar(res.message!);
          this.close.emit();
        },
        error: (e) => {
          this.submitted.set(false);
          this.snackbar.showSnackbar(e.networkError.message, SnackbarType.error);
        },
      });
  }
}
